import type {
  AnalyticsCompanyTrait,
  AnalyticsEvent,
  AnalyticsIntegrationEvent,
  AnalyticsUserTrait,
} from './types/analytics';
import { getGlobalHandle } from './helpers';

interface Identity {
  visitor?: Partial<Record<AnalyticsUserTrait, any>>;
  account?: Partial<Record<AnalyticsCompanyTrait, any>>;
}

interface EventCallbacks {
  ready?(): void;
  guidesLoaded?(): void;
  guidesFailed?(): void;
}

interface InitOptions extends Identity {
  apiKey?: string;
  excludeAllText?: boolean;
  excludeTitle?: boolean;
  disableCookies?: boolean;
  disablePersistence?: boolean;
  guides?: {
    delay?: boolean;
    timeout?: number;
    tooltip?: {
      arrowSize?: number;
    };
  };
  events?: EventCallbacks;
}

export default class Pendo {
  static initialize(options: InitOptions): void {
    getGlobalHandle().pendo.initialize(options);
  }
  static identify(identity: Identity): void {
    getGlobalHandle().pendo.identify(identity);
  }
  static track(
    event: AnalyticsEvent | AnalyticsIntegrationEvent,
    metadata?: Partial<Record<AnalyticsUserTrait | AnalyticsCompanyTrait, any>>
  ): void {
    getGlobalHandle().pendo.track(event, metadata);
  }
  static isReady(): boolean {
    return getGlobalHandle().pendo.isReady();
  }
  static flushNow(): Promise<any> {
    return getGlobalHandle().pendo.flushNow();
  }
  static getVersion(): string {
    return getGlobalHandle().pendo.flushNow();
  }
  static getVisitorId(): string {
    return getGlobalHandle().pendo.getVisitorId();
  }
  static getAccountId(): string {
    return getGlobalHandle().pendo.getAccountId();
  }
  static getCurrentUrl(): string {
    return getGlobalHandle().pendo.getCurrentUrl();
  }
  static showGuideById(id: string): void {
    getGlobalHandle().pendo.showGuideById(id);
  }
}
